import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthConfig, LanguageService } from '@spartacus/core';
import { filter } from 'rxjs';

import { PageSlotModule } from '@spartacus/storefront';

import {
  OmnibusRecommendedPriceModalComponent
} from '@seb/web-common/core/components/static/omnibus-recommended-price-modal/omnibus-recommended-price-modal.component';

import { AbstractPageComponent } from '@seb/web-common/core/templates/abstract-page/abstract-page.component';
import { AuthenticationConfigInitializer } from '@seb/web-common/core/config/initializers/authentication-config.initializer';
import { MyOrdersComponent } from '../../components/my-orders/my-orders.component';
import { ReturnProductsComponent } from '../../components/return-products/return-products.component';
import { MyAccountInformationComponent } from '../../components/my-account-information/my-account-information.component';
import { MyAccountDashboardComponent } from '../../components/my-account-dashboard/my-account-dashboard.component';
import { MyAccountProductsComponent } from '../../components/my-account-products/my-account-products.component';
import { CoreModalService, SdLoaderComponent } from '@seb/web-design-system/core';
import { BaseStoreService, ConfigurationService } from '@seb/web-common/core/services';
import { IFrameResizerDirective } from '@seb/web-common/core/directives';
import { MyAccountSponsorshipsComponent } from '../../components/my-account-sponsorships/my-account-sponsorships.component';

@Component({
  selector: 'wc-account-page',
  templateUrl: './account-page.component.html',
  styleUrls: ['./account-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    PageSlotModule,
    MyOrdersComponent,
    ReturnProductsComponent,
    MyAccountInformationComponent,
    MyAccountDashboardComponent,
    MyAccountProductsComponent,
    MyAccountSponsorshipsComponent,
    IFrameResizerDirective,
    SdLoaderComponent,
    OmnibusRecommendedPriceModalComponent
  ],
  providers: [CoreModalService]
})
export class AccountPageComponent extends AbstractPageComponent implements OnInit {
  currentPage: string;
  newsletterLink: SafeResourceUrl;
  newsletterIsLoading = false;
  isOpenedRecommendedModal = false;

  constructor(
    private configService: ConfigurationService,
    private baseStoreService: BaseStoreService,
    private sanitizer: DomSanitizer,
    private languageService: LanguageService,
    private authConfig: AuthConfig,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.subscriptions.add(
      this.cmsService.getCurrentPage().pipe(
        filter((p) => !!p)
      ).subscribe((page) => {
        this.currentPage = page.label;
        if (this.currentPage === '/my-newsletters') {
          this.newsletterIsLoading = true;
          this.createDynamicNewsletterUrl();
        }
        this.cdRef.markForCheck();
      })
    );
  }

  openRecommendedPriceModal() {
    this.isOpenedRecommendedModal = true;
  }

  private createDynamicNewsletterUrl(): void {
    const baseStore = this.baseStoreService.baseStore;
    const config = this.configService.config;

    this.subscriptions.add(
      this.languageService.getActive().subscribe((language) => {
        const expId = AuthenticationConfigInitializer.getExpId(baseStore, config, language);
        this.newsletterLink = this.sanitizer.bypassSecurityTrustResourceUrl(
          `${this.authConfig.authentication.baseUrl}/MyNewsletters?expid=${expId}`
        );
        this.cdRef.markForCheck();
      })
    );
  }
}
